"use client";
import { useHasMounted } from "@core/hooks/useHasMounted";
import { ToastContainer, toast } from "react-toastify";

export const CustomAlert = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
};

export const SuccessAlert = (msg: string) => toast.success(msg);
export const ErrorAlert = (msg: string) => toast.error(msg);
export const WarningAlert = (msg: string) => toast.warning(msg);
export const InfoAlert = (msg: string) => toast.info(msg);
